import { render, staticRenderFns } from "./afterSaleApproveDetail.vue?vue&type=template&id=5f984528&scoped=true&"
import script from "./afterSaleApproveDetail.vue?vue&type=script&lang=js&"
export * from "./afterSaleApproveDetail.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleApproveDetail.vue?vue&type=style&index=0&id=5f984528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f984528",
  null
  
)

export default component.exports